import { useLocation } from 'react-router-dom';

import { getMappedFeedbackFormType } from 'constants/helper';

export const useGenerateFeedbackDrawerParams = ({
  formType,
  newForm,
  empId,
  source,
  isSharePublicPraise,
}: {
  formType: string;
  newForm: boolean;
  empId: null | string;
  source?: string;
  isSharePublicPraise?: boolean;
}) => {
  const { search } = useLocation();
  const mappedFormType = getMappedFeedbackFormType({ formType, newForm });

  const urlParams = new URLSearchParams(search);

  urlParams.set('formType', mappedFormType);
  if (empId) {
    urlParams.set('empId', empId);
  }
  if (source) {
    urlParams.set('source', source);
  }
  if (isSharePublicPraise) {
    urlParams.set('isSharePublicPraise', 'true');
  }
  if (!isSharePublicPraise) {
    urlParams.delete('isSharePublicPraise');
  }

  urlParams.set('showFeedback', 'true');

  return urlParams.toString();
};
